import { render } from "./Label.vue?vue&type=template&id=1ffa232b&scoped=true&lang=pug"
import script from "./Label.vue?vue&type=script&lang=ts"
export * from "./Label.vue?vue&type=script&lang=ts"

import "./Label.vue?vue&type=style&index=0&id=1ffa232b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1ffa232b"

export default script